import React, {
  Fragment,
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
  forwardRef,
} from 'react';
import ReactDOM from 'react-dom';

export default React;
export {
  Fragment, ReactDOM, Suspense, useCallback, useEffect, useMemo, useRef, useState, forwardRef,
};
